import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ColumnClassNamesType from '../../../propTypes/columnClassNamesType';

const BulkCheckboxCell = ({ contact, value, itemIsSelected, toggleTrackedItem, columnClassNames }) => {
  if (!value || (typeof value === 'function' && !value(contact))) {
    return <td />;
  }

  return (
    <td className={classNames(columnClassNames)}>
      <input
        className='contact-list-react-checkbox'
        type='checkbox'
        value={contact.id}
        checked={itemIsSelected(contact.id)}
        onChange={toggleTrackedItem}
      />
    </td>
  );
};

BulkCheckboxCell.propTypes = {
  /* contact for the row - with the id used for tracking */
  contact: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,

  /* used to determine if we should add a checkbox to this row */
  value: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /* Usually from useBulkActions */
  itemIsSelected: PropTypes.func.isRequired,

  /* Usually from useBulkActions */
  toggleTrackedItem: PropTypes.func.isRequired,

  columnClassNames: ColumnClassNamesType
};

BulkCheckboxCell.defaultProps = {
  value: '',
  columnClassNames: ''
};

export default BulkCheckboxCell;
